import Vue from 'vue';
import Router from 'vue-router';
import routerConfigFn from './routerConfig';
import options from '../../resource/router/officialSupport';
import store from '../stores/officialSupport';
import {
  guardOfficialSupportLogin,
  isOfficialSupportLoginGuardRoute
} from '../../resource/utiles/officialSupport/requireLogin';

Vue.use(Router);

const router = new Router(routerConfigFn(options));

// workhome / mylist 进入前校验登录；未登录整页跳 gabres login，须 next(false) 避免守卫挂起
router.beforeEach(async (to, _from, next) => {
  if (!isOfficialSupportLoginGuardRoute(to.name)) {
    next();
    return;
  }
  const canProceed = await guardOfficialSupportLogin(store);
  if (canProceed) {
    next();
  } else {
    next(false);
  }
});

export default router;
